import {FBFieldBaseOptions, FieldTypeEnum} from "FormBuilder/Fields/Core/FBFieldBase.options";


export class FBParagraphOptions extends FBFieldBaseOptions{
    public Text:string;



    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.Type=FieldTypeEnum.Paragraph;
        this.Label='Paragraph';
        this.Text='<p>Paragraph field</p>';
    }


}

